import JChartHistogram from './Control_Charts'
export { JChartHistogram }
export default JChartHistogram